import React, { useEffect } from 'react'
import { loadDatadogRum } from './datadogLoader'
import getConfig from 'src/common/runtimeConfig'

const DATADOG_DEFER_MS = 4000
const DATADOG_IDLE_TIMEOUT_MS = 10000
const REPLAY_DEFER_MS = 8000

const DATADOG_RUM_SERVICE = {
  DATADOG_SITE: 'datadoghq.com',
  DATADOG_SERVICE: 'fdr-website',
}

const DatadogRum = () => {
  const {
    NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID: appId,
    NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN: clientToken,
    NEXT_PUBLIC_DATADOG_RUM_ENV: env,
    NEXT_PUBLIC_APP_VERSION: appVersion,
  } = getConfig().publicRuntimeConfig

  useEffect(() => {
    if (!appId || !clientToken || !env) return undefined

    let cancelled = false
    let replayTimerId

    const startReplay = (datadogRum) => {
      if (cancelled) return
      replayTimerId = window.setTimeout(() => {
        if (!cancelled) datadogRum.startSessionReplayRecording()
      }, REPLAY_DEFER_MS)
    }

    const initializeDatadogRum = async () => {
      const datadogRum = await loadDatadogRum()
      if (cancelled || !datadogRum) return

      datadogRum.init({
        applicationId: appId,
        clientToken,
        env,
        site: DATADOG_RUM_SERVICE.DATADOG_SITE,
        service: DATADOG_RUM_SERVICE.DATADOG_SERVICE,
        version: appVersion || '0.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        defaultPrivacyLevel: 'allow',
      })

      startReplay(datadogRum)
    }

    const startedAt = Date.now()

    const runDeferred = () => {
      const elapsed = Date.now() - startedAt
      if (elapsed < DATADOG_DEFER_MS) {
        window.setTimeout(runDeferred, DATADOG_DEFER_MS - elapsed)

        return
      }

      initializeDatadogRum()
    }

    let idleId
    if ('requestIdleCallback' in window) {
      idleId = window.requestIdleCallback(runDeferred, {
        timeout: DATADOG_IDLE_TIMEOUT_MS,
      })
    } else {
      idleId = window.setTimeout(runDeferred, DATADOG_DEFER_MS)
    }

    return () => {
      cancelled = true
      if (replayTimerId != null) window.clearTimeout(replayTimerId)
      if (typeof idleId === 'number') {
        window.clearTimeout(idleId)
      } else if (idleId != null && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleId)
      }
    }
  }, [appId, appVersion, clientToken, env])

  return null
}

export default DatadogRum
